// schema-upgrader/components/_global.ts
import { has } from 'lodash-es'
import { UpgradeRegistryItem } from '../upgrader.types'
import { updateByWidget } from '../../utils/system-tools'

/**
 * 通用升级器
 * form 为需要执行的版本
 * to 仅作为执行顺序排序依据，升序排序
 */
export const globalUpgrades: UpgradeRegistryItem = {
  component: '*', // 星号代表全局生效
  upgrades: [
    {
      from: 1,
      to: 2,
      upgrade(schema) {
        // 统一为不包含version字段的，也即是2.6.8之前的版本进行一次统一的属性更新
        // 执行当前全局页面属性
        updateByWidget(schema)
        return schema
      }
    },
    {
      // 金库属性
      from: 2,
      to: 3,
      upgrade(schema) {
        // 统一为不包含version字段的，也即是2.6.8之前的版本进行一次统一的属性更新
        // 执行当前全局页面属性
        updateByWidget(schema)
        return schema
      }
    }
  ]
}
